/**
 * localStorage keys for slideout section UI state (single source of truth for string literals).
 */
export const SLIDEOUT_STORAGE_KEYS = {
  changeLogExpanded: 'slideout_change_log_expanded'
} as const;
